<template>
  <v-menu
    location="bottom center"
    :offset="[8, 0]"
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        icon="mds:account-circle"
      />
    </template>

    <v-list density="compact">
      <template v-if="isUserLoggedIn">
        <v-list-item :to="{ path: '/account' }" prepend-icon="mds:person">
          <v-list-item-title>My profile</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/subscription/my-plan' }" prepend-icon="mdi-account-credit-card-outline"
                     v-if="subscriptionAccessType !== 'NO_ACCESS'">
          <v-list-item-title>Plan & Billing</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/settings' }" prepend-icon="mds:corporate-fare"
                     v-if="subscriptionAccessType !== 'NO_ACCESS'">
          <v-list-item-title>My organisations</v-list-item-title>
        </v-list-item>

        <v-list-item @click="logout" prepend-icon="mds:logout">
          <v-list-item-title>Log out</v-list-item-title>
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item @click="logout" prepend-icon="mds:login">
          <v-list-item-title>Log in</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { authHelpers } from '@/api/authHelpers'
import useBroadcastChannel from '@/composables/useBroadcastChannel'

const store = useStore()
const router = useRouter()
const { sendMessage } = useBroadcastChannel()

const isUserLoggedIn = computed(() => store.state.isUserLoggedIn)
const userInfo = computed(() => store.state.userInfo)
const subscriptionAccessType = computed(() => store.state.payments.subscriptionAccessType)

const logout = () => {
  sendMessage('LOGOUT', { loggedInUser: userInfo.value })
  authHelpers.logoutAndClearStore()
  router.push({ path: '/login' })
}
</script>
